import apiClient from "./client";
import type { ApiErrorResponse } from "./events";
import type { EventTemplateDefinition } from "@/lib/event-templates";

export async function getEventTemplates(): Promise<EventTemplateDefinition[]> {
  const response = await apiClient.get<EventTemplateDefinition[] | ApiErrorResponse>("/templates");
  const data = response.data;

  if ("error" in data) {
    throw new Error(data.error?.message || "Failed to load templates");
  }

  return data as EventTemplateDefinition[];
}

export async function applyEventTemplate(eventUuid: string, templateKey: string): Promise<void> {
  await apiClient.post(`/events/${eventUuid}/template`, { template: templateKey });
}

